import React, { useEffect, useState } from 'react'
import styles from './index.module.css'
import { Input } from '../../../../components/ModalInputs'
import Button from '../../../../components/Button'
import { createStudyPlanVDFile, getStudyPlanVDFiles, } from '../../../../actions/studyPlansVD'
import { createNotification } from '../../../../components/Notifications/Notifications'
import { useDispatch, useSelector } from 'react-redux'
import { getSubjectsExtraCurEdu } from '../../../../actions/directoryExtraCurEducation'
import { getParallels } from '../../../../actions/common'
import { getSubjectsExtraEdu } from '../../../../actions/directoryExtraEducation'
import { api } from '../../../../App'


const Index = ({ values, setFieldValue, handleChange, image, setImage }) => {

    const dispatch = useDispatch()
    const { files } = useSelector(state => state.studyPlansVD)

    const [file, setFile] = useState(null);

    useEffect(() => {
        values?.xp_key && dispatch(getStudyPlanVDFiles(values.xp_key))
    }, [values])

    useEffect(() => {
        if (!files) setImage(null);
        if (!files) return;
        fetchPhoto(files[0]?.file_name, values?.xp_key)
    }, [files])


    const handleAddFile = () => {
        if (file) {
            dispatch(createStudyPlanVDFile(file, values.xp_key));
        } else {
            createNotification('error', 'Выберите файл');
        }
        setFile('');
    }

    const handlePick = () => {
        document.getElementById('filePicker').click()
    }

    const handleChangeFile = (e) => {
        setFile(Object.values(e.target.files)[0])
        setImage(Object.values(e.target.files)[0])
    }

    const fetchPhoto = async (file_name, id) => {
        const { data } = id && await api.get(`/out_study_plans/${id}/${file_name}`, { responseType: 'blob' })
        setImage(data)
    }

    useEffect(() => {
        file && handleAddFile()
    }, [file])

    useEffect(() => {
        dispatch(getSubjectsExtraCurEdu({ status: "Идет" }))
    }, [])

    return (
        <div className={styles.tabWrapper}>
            <div className={styles.inputsRow}>
                <Input
                    error={values.name === '' ? 'Обязательное поле' : ''}
                    label='Название'
                    name='name'
                    value={values.name}
                    maxLength={50}
                    onChange={handleChange} />
            </div>

            <div className={styles.inputsColumn}>
                <Input
                    label='Ступень образования'
                    name='description'
                    maxLength={25}
                    value={values.description}
                    onChange={handleChange} />

            </div>
            <br />
            <div className={styles.buttons_wrap}>
                <div className={styles.buttons}>
                    <>
                        <Button onClick={handlePick}>{image ? 'Изменить фото' : 'Загрузить фото'}</Button>
                        <input
                            className={styles.hidden}
                            type='file'
                            onChange={(e) => handleChangeFile(e)}
                            accept="image/*"
                            id='filePicker'
                        />
                    </>

                </div>
            </div>
            <div>
                {!!image &&
                    <img
                        src={URL.createObjectURL(image)}
                        alt="0_o"
                        height={350}
                        width={450}
                    />
                }
            </div>

        </div>

    )
}

export default Index